import script from "./svg-disease-coverage-1.vue?vue&type=script&lang=ts&setup=true"
export * from "./svg-disease-coverage-1.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__